<template>
  <div class="w100 pl20 pr20 flex-box tab-bar" v-if="tabData.length">
    <div class="cu-p tab-bar-item" v-for="(item, index) in tabData" :key="index" :class="item.index == value ? 'active' : null" @click="changeValue(item, index)">{{ item.name }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "TabBar",
  components: {},
  props: {
    value: {
      type: String
    },
    "tab-data": {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      editeValue: this.value
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    changeValue(item, index) {
      this.editeValue = item.index;
      this.$emit("change", {
        item,
        $index: index
      });
    }
  },
  watch: {
    value(value) {
      this.editeValue = value;
    },
    editeValue(value) {
      this.$emit("input", value);
    }
  },
  filters: {}
};
</script>

<style scoped>
.tab-bar {
  border-bottom: 1px solid #248ff0;
}

.tab-bar-item {
  margin-right: 10px;
  padding: 0.5em 1.5em;
  border: 1px solid #ccc;
  border-bottom: none;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  font-size: 14px;
}

.tab-bar-item:hover {
  border-color: #248ff0;
  color: #248ff0;
}

.tab-bar-item.active {
  color: #fff;
  background: #248ff0;
  border-color: #248ff0;
}
</style>
